import { render, staticRenderFns } from "./Porlet.vue?vue&type=template&id=722a9661"
import script from "./Porlet.vue?vue&type=script&lang=js"
export * from "./Porlet.vue?vue&type=script&lang=js"
import style0 from "./Porlet.vue?vue&type=style&index=0&id=722a9661&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports